import { InitialState } from "./InitialState";
import { ACTIONS, Actions, IStatePayload } from "./actions";

export const initialState: InitialState = {
  authenticated: false,
};

export function reducer(
  state = initialState,
  action: Actions<Partial<IStatePayload>>,
): InitialState {
  switch (action.type) {
    case ACTIONS.SET_AUTHENTICATED:
      return {
        ...state,
        authenticated: action.payload.authenticated || false,
      };
    default:
      return state;
  }
}
